import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=f573df98&scoped=true&"
import script from "./BaseContainer.vue?vue&type=script&lang=js&"
export * from "./BaseContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=f573df98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f573df98",
  null
  
)

export default component.exports